var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 45,
    viewBox: "0 0 54 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72363 11.2086V6.70685C6.72363 5.5129 7.19792 4.36786 8.04217 3.52362C8.88641 2.67937 10.0315 2.20508 11.2254 2.20508H15.7272",
    stroke: "white",
    strokeWidth: 1.70526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2334 2.20508H42.7352C43.9291 2.20508 45.0742 2.67937 45.9184 3.52362C46.7626 4.36786 47.2369 5.5129 47.2369 6.70685V11.2086",
    stroke: "white",
    strokeWidth: 1.70526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2369 33.7168V38.2186C47.2369 39.4125 46.7626 40.5575 45.9184 41.4018C45.0742 42.246 43.9291 42.7203 42.7352 42.7203H38.2334",
    stroke: "white",
    strokeWidth: 1.70526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7272 42.7203H11.2254C10.0315 42.7203 8.88641 42.246 8.04217 41.4018C7.19792 40.5575 6.72363 39.4125 6.72363 38.2186V33.7168",
    stroke: "white",
    strokeWidth: 1.70526,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2929 18.0706L23.031 19.7531C22.9648 19.8414 22.879 19.913 22.7804 19.9623C22.6817 20.0117 22.5729 20.0374 22.4626 20.0374H22.1784C21.7638 20.0374 21.3662 20.202 21.0731 20.4952C20.7799 20.7883 20.6152 21.1859 20.6152 21.6005V27.2847C20.6152 27.6993 20.7799 28.0969 21.0731 28.39C21.3662 28.6832 21.7638 28.8479 22.1784 28.8479H31.2731C31.6877 28.8479 32.0853 28.6832 32.3784 28.39C32.6716 28.0969 32.8363 27.6993 32.8363 27.2847V21.6005C32.8363 21.1859 32.6716 20.7883 32.3784 20.4952C32.0853 20.202 31.6877 20.0374 31.2731 20.0374H30.9889C30.8786 20.0374 30.7698 20.0117 30.6712 19.9623C30.5725 19.913 30.4867 19.8414 30.4205 19.7531L29.1586 18.0706C29.0871 17.9753 28.9944 17.898 28.8879 17.8447C28.7813 17.7914 28.6638 17.7637 28.5447 17.7637H24.9068C24.6652 17.7637 24.4379 17.8774 24.2929 18.0706ZM26.7258 21.1742C26.3712 21.1742 26.0201 21.244 25.6925 21.3797C25.3649 21.5154 25.0673 21.7143 24.8166 21.965C24.5659 22.2157 24.367 22.5134 24.2313 22.841C24.0956 23.1685 24.0258 23.5196 24.0258 23.8742C24.0258 24.2288 24.0956 24.5799 24.2313 24.9074C24.367 25.235 24.5659 25.5327 24.8166 25.7834C25.0673 26.0341 25.3649 26.233 25.6925 26.3687C26.0201 26.5044 26.3712 26.5742 26.7258 26.5742C27.4418 26.5742 28.1286 26.2897 28.6349 25.7834C29.1413 25.277 29.4258 24.5903 29.4258 23.8742C29.4258 23.1581 29.1413 22.4714 28.6349 21.965C28.1286 21.4587 27.4418 21.1742 26.7258 21.1742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.5e3beb6cfca96f8cc3c296b14aa3c5a8.svg";
export { ForwardRef as ReactComponent };